import { configureStore } from "@reduxjs/toolkit";

//--------------------- admin --------------------
import { authSlice } from "./slices/admin/session/auth";
import { meSlice } from "./slices/admin/me.slice.js";
import { settingsSlice } from "./slices/admin/settings/settings.slice";
import { toastSlice } from "./slices/common/toast.slice";
import { adminModalSlice } from "./slices/common/adminModal.slice";
import { cmsSlice } from "./slices/admin/cms";
import { rolesSlice } from "./slices/admin/membersAndRoles/roles";
import { accessSlice } from "./slices/admin/membersAndRoles/permission";
import { accessUsersSlice } from "./slices/admin/membersAndRoles/teamMembers";
import { dashboardSlice } from "./slices/admin/dashboard";
import { languagesSlice } from "./slices/admin/dataManagement/language";
import { rejectReasonSlice } from "./slices/admin/dataManagement/rejectReason";
import { countrySlice } from "./slices/admin/dataManagement/country";
import { userSlice } from "./slices/admin/users";
import { tagsSlice } from "./slices/admin/dataManagement/tags";
import { fullScreenMediaSlice } from "./slices/common/fullScreenMedia.slice";
import { checkInSlice } from "./slices/admin/checkIn";
import { templatesSlice } from "./slices/admin/dataManagement/messageTemplate";
import { badgeSlice } from "./slices/admin/dataManagement/badge";
import { eventlistingSlice } from "./slices/admin/dataManagement/eventlisting";

function configStore() {
  const store = configureStore({
    reducer: {
      auth: authSlice.reducer,
      me: meSlice.reducer,
      dashboard: dashboardSlice.reducer,
      settings: settingsSlice.reducer,
      toast: toastSlice.reducer,
      adminModal: adminModalSlice.reducer,
      cms: cmsSlice.reducer,
      roles: rolesSlice.reducer,
      access: accessSlice.reducer,
      accessUsers: accessUsersSlice.reducer,
      languages: languagesSlice.reducer,
      rejectReasons: rejectReasonSlice.reducer,
      country: countrySlice.reducer,
      user: userSlice.reducer,
      fullScreenMedia: fullScreenMediaSlice.reducer,
      checkIn: checkInSlice.reducer,
      tags: tagsSlice.reducer,
      messagetemplate: templatesSlice.reducer,
      badge: badgeSlice.reducer,
      eventlisting: eventlistingSlice.reducer,
      // Add other reducers if needed
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }),
  });
  return store;
}

export default configStore;
